
export default {
  component:          "pe-md-progress-spinner",

  // elements
  animation:          "pe-md-progress-spinner__animation",
  circle:             "pe-md-progress-spinner__circle",
  circleRight:        "pe-md-progress-spinner__circle-right",
  circleLeft:         "pe-md-progress-spinner__circle-left"
};
